// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "js/" + "settings-vendors" + "-" + "106f331320e78c6f" + ".js"
}